module.exports = __webpack_public_path__ + "img/20.b0952b11.jpg";